import axiosInstance from "../utils/api";
import noDecryptInstance from "../utils/noDecryptApi";

const commonService = {
    import: async ({ formData,
        moduleName,
        extension }) => {
        try {
            console.log(formData, 'formData');
            console.log(moduleName, 'moduleName');
            console.log(extension, 'extension');

            const result = {
                data: {
                    data:
                    {
                        statusCode: 201,
                        IsSuccess: true,
                        successMessage: "The file has been uploaded successfully."
                    }
                }
            }
            return result.data;
        } catch (error) {
            return error;
        }
    },
    export: async ({ query = '', moduleName, filters = null }) => {
        try {
            let result = '';
            if (!query && !filters) {
                result = await noDecryptInstance.get(`/${moduleName}/export`, { responseType: 'blob' });
            } else if (!filters) {
                result = await noDecryptInstance.get(`/${moduleName}/export?${query}`, { responseType: 'blob' });
            } else if (!query) {
                result = await noDecryptInstance.post(`/${moduleName}/export`, filters, { responseType: 'blob' });
            } else {
                result = await noDecryptInstance.post(`/${moduleName}/export?${query}`, filters, { responseType: 'blob' });
            }
            return result;
        } catch (error) {
            return error.response;
        }
    },
    dropdown: async ({ filters, moduleName, id, purpose }) => {
        try {
            let result = {};
            if (purpose) {
                result = await axiosInstance.get(`/dropdowns/${moduleName}/${id}/${purpose}`);
            } else if (id) {
                result = await axiosInstance.get(`/dropdowns/${moduleName}/${id}`);
            } else {
                result = await axiosInstance.get(`/dropdowns/${moduleName}`);
            }
            return result;
        } catch (error) {
            return error.response;
        }
    }
};

export default commonService;
